/*
 * @Author: Roman
 * @Date: 2023-05-12 17:52:41
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2023-08-16 16:03:40
 * @FilePath: \qpmn-site\src\app\modules\common\rest\currency\wooc-currency\wooc-currency-rest.config.ts
 * @Description: 
 */
/*
 * @Description: WooCommerece货币接口
 */


import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";
let WoocCurrencyRestServiceConfig: IRestfulConfigMap = {
    woocCurrencyRestService: {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            default: {
                method: "get",
                path: "api/stores/:storeId/defaultCurrency",
                testPath: "api/stores/:storeId/defaultCurrency",
                paramDefaults: {
                    "storeId": "@storeId"
                }
            }
        }
    }
}


export { WoocCurrencyRestServiceConfig };